import { render, staticRenderFns } from "./PersonQuickViewModal.vue?vue&type=template&id=cfe23bc2&scoped=true&"
import script from "./PersonQuickViewModal.vue?vue&type=script&lang=js&"
export * from "./PersonQuickViewModal.vue?vue&type=script&lang=js&"
import style0 from "./PersonQuickViewModal.vue?vue&type=style&index=0&id=cfe23bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe23bc2",
  null
  
)

export default component.exports